import { render, staticRenderFns } from "./hisWorkData.vue?vue&type=template&id=46dbce23&"
import script from "./hisWorkData.vue?vue&type=script&lang=js&"
export * from "./hisWorkData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports